import { Typography, FlexGrid, Divider, ButtonLink, Spacer, ExpandCollapseMini } from '@telus-uds/components-web'
import { LegalTextRenderer } from '@/siteBuilder/utils/text/TextRenderer'
import {
  RateText,
  BottomRowPadding,
  BottomTextStyle,
  ButtonStyle,
  ProductPriceTextStyle,
  ExpandLeftShift,
} from './Styles'
import { BlockRenderer } from '../../../renderer/contentful/BlockRenderer'
import ProductDetailsSection from './ProductDetailsSection'
import ExtraDetailsSection from './ExtraDetailsSection'
import { IconProps } from '../../core/Icon/Icon'
import { DetailsSectionProps } from './DetailsSection'
import { PlanSectionDetailFields } from './PlanSection'

export const renderSpeedInfo = (speed: string, rate: string, color: string) => {
  return (
    <>
      {speed && (
        <Typography variant={{ size: 'display1' }}>
          <LegalTextRenderer>{speed}</LegalTextRenderer>
        </Typography>
      )}
      {rate && (
        <RateText>
          <Typography tokens={{ color }}>
            <LegalTextRenderer>{rate}</LegalTextRenderer>
          </Typography>
        </RateText>
      )}
    </>
  )
}

export const renderButtonText = (
  buttonText: string,
  color: string,
  isMobile: boolean,
  buttonURL: string,
  productBottomText: string
) => {
  return (
    <>
      <BottomRowPadding>
        <Divider variant={{ decorative: true }} />
        <FlexGrid.Row>
          <FlexGrid.Col xs={12} md={7}>
            <BottomTextStyle>
              <Typography>
                <Typography tokens={{ color }}>
                  <LegalTextRenderer>{productBottomText}</LegalTextRenderer>
                </Typography>
              </Typography>
            </BottomTextStyle>
          </FlexGrid.Col>
          <FlexGrid.Col xs={12} md={5} horizontalAlign={isMobile ? 'center' : 'right'}>
            <ButtonStyle>
              <ButtonLink href={buttonURL} rank="main">
                {buttonText}
              </ButtonLink>
            </ButtonStyle>
          </FlexGrid.Col>
        </FlexGrid.Row>
      </BottomRowPadding>
    </>
  )
}

export const renderProductInfo = (
  productIcon: IconProps,
  productTitle: string,
  productPriceText: string,
  color: string
) => {
  return (
    <>
      {productIcon && (
        <FlexGrid.Col xs={12}>
          <BlockRenderer block={productIcon} />
          <Spacer space={1} />
          <Spacer space={2} />
        </FlexGrid.Col>
      )}
      {productTitle && (
        <FlexGrid.Col xs={12}>
          <Typography block variant={{ size: 'h3' }}>
            <LegalTextRenderer>{productTitle}</LegalTextRenderer>
            <Spacer space={3} />
          </Typography>
        </FlexGrid.Col>
      )}
      {productPriceText && (
        <FlexGrid.Col xs={12}>
          <ProductPriceTextStyle>
            <Typography variant={{ size: 'small' }} tokens={{ color }}>
              <LegalTextRenderer>{productPriceText}</LegalTextRenderer>
            </Typography>
          </ProductPriceTextStyle>
        </FlexGrid.Col>
      )}
    </>
  )
}

export const renderExpandCollapse = (
  collapseButtonText: string,
  expandButtonText: string,
  expandDetailsSection: DetailsSectionProps[] | false,
  margin: number,
  extraDetailsSection: PlanSectionDetailFields[],
  color: string
) => {
  return (
    <div data-testid="collapser">
      <ExpandCollapseMini expandTitle={collapseButtonText} collapseTitle={expandButtonText}>
        {expandDetailsSection &&
          expandDetailsSection.map((section, idx) => {
            return (
              <ExpandLeftShift key={idx}>
                <Spacer space={2} />
                {section.sectionTitle && (
                  <div>
                    <Typography block variant={{ size: 'h4' }} tokens={{ color }}>
                      <LegalTextRenderer>{section.sectionTitle}</LegalTextRenderer>
                    </Typography>
                    <Spacer space={2} />
                  </div>
                )}
                {section.sectionDetails &&
                  section.sectionDetails.map((sectionDetail, _idx) => {
                    return <ProductDetailsSection key={_idx} sectionDetail={sectionDetail} IMAGE_LEFT_MARGIN={margin} />
                  })}
              </ExpandLeftShift>
            )
          })}
        {extraDetailsSection && (
          <ExpandLeftShift>
            <ExtraDetailsSection extraDetailsSection={extraDetailsSection} />
          </ExpandLeftShift>
        )}
      </ExpandCollapseMini>
    </div>
  )
}
